import { Component, Input, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { Subscription, lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { JsonDataService } from '../../services/json-data.service';
import { MetaMgmtService } from '../../services/meta-mgmt.service';
import { ProductDetailService } from '../../services/product-detail.service';
import { SkeletonService } from '../../services/skeleton.service';
import { UtilsService } from '../../services/utils.service';
import { MyReviewsService } from '../../services/my-reviews.service';
import { CommonModule,Location } from '@angular/common';
import { WriteReviewComponent } from '../../../app/components/write-review/write-review.component';

@Component({
  selector: 'app-all-reviews',
  standalone: true,
  imports: [CommonModule,RouterModule],
  templateUrl: './all-reviews.component.html',
  styleUrl: './all-reviews.component.scss'
})
export class AllReviewsComponent implements OnDestroy {
  environment: any = environment;
  activeRoute: string = '';
  @Input('reviewData') reviewData: any;
  @Input('productGuidId') productGuidId: any
  @Input('productName') productName: any;
  @Input('pageName') pageName!:string;
  pinCode: any;
  sub:Subscription=new Subscription()
  reviewPageName:any;
  plpMetaData: any;

  constructor(public router: Router, public route: ActivatedRoute, public dialog: MatDialog, public utils: UtilsService, public service: ProductDetailService, public myReviewService: MyReviewsService, private _location: Location, private jsonDataService: JsonDataService, private metaSvc: MetaMgmtService) {
    this.utils.showHeaderFooter.next(true);
    this.pinCode = this.utils.getUserPicode() ? this.utils.getUserPicode() : 0;
    this.sub.add( this.router.events.subscribe(events => {
      if (events instanceof NavigationEnd) {
        this.activeRoute = router.url;
      }
    }));
    if (this.router.url.includes('all-reviews')) {
      this.sub.add( this.route.params.subscribe(params => {
        this.productGuidId = params['guidid']?params['guidid']:'';
        this.reviewPageName=params['pageName']?params['pageName']:'',
        this.getProductInfo();
      }))
    }
    if(this.reviewPageName) {
      this.getJsonDataAsync();
    }
  }

  async getJsonDataAsync() {
    try {
      const res = await lastValueFrom(this.jsonDataService.getProductListingMetaDataJsonData());
      this.plpMetaData = res;
      let metaDataFilter: any;
      let canonicalUrl = environment.baseApiURl + this.router.url;
      metaDataFilter = this.plpMetaData.filter((x: any) => {
        if (this.reviewPageName == x.name) return x;
      });
      let metaData: any = {
        canonicalURL: canonicalUrl,
        description: metaDataFilter[0] && metaDataFilter[0].description ? metaDataFilter[0].description : '',
        pageTitle: metaDataFilter[0] && metaDataFilter[0].title ? metaDataFilter[0].title : '',
        keywords: metaDataFilter[0] && metaDataFilter[0].keywords ? metaDataFilter[0].keywords : ''
      }
      this.metaSvc.updateMetaTags(metaData);
    } catch (error) {
      console.error('Error fetching JSON data', error);
    }
  }

  openReviewDialog(): void {
    if (this.utils.getUser()) {
      if (this.reviewData.isReviewSubmitted) {
        this.utils.showLoading()
        this.sub.add( this.myReviewService.getUserReview('pending').subscribe(
          (response: any) => {
            if (response) {
              this.utils.hideLoading()
              let revResponse = response.myReviewResponse.filter((rev: any) => { return rev.productGuidId == this.productGuidId })
              const dialogRef = this.dialog.open(WriteReviewComponent, {
                disableClose: true,
                maxWidth: '799px',
                width: '100%',
                data: {
                  reviews: revResponse[0].rating,
                  productGuidId: this.productGuidId ? this.productGuidId : '',
                  productName: this.productName ? this.productName : '',
                  description: revResponse[0].reviewDescription,
                  title: revResponse[0].reviewTitle,
                  isReviewSubmitted: this.reviewData.isReviewSubmitted,
                  reviewGuidId: revResponse[0].reviewGuidId
                },
              })
              this.sub.add(dialogRef.afterClosed().subscribe((res) => {
                if (res) {
                  this.utils.openSnackBar('Successfully updated.', 'success-toster')
                }
              }));
            }
            else {
              this.utils.hideLoading()
              this.utils.openSnackBar(response.message, 'error-toster')
            }
          }
        ))
      }
      else {
        const dialogRef = this.dialog.open(WriteReviewComponent, {
          disableClose: true,
          maxWidth: '799px',
          width: '100%',
          data: {
            reviews: this.reviewData.overAll.filter((obj: any) => { return obj.name != 'Overall Rating' }),
            productGuidId: this.productGuidId ? this.productGuidId : '',
            productName: this.productName ? this.productName : '',
            isReviewSubmitted: this.reviewData.isReviewSubmitted
          }
        })
        this.sub.add( dialogRef.afterClosed().subscribe((res) => {
          if (res) {
            this.utils.openSnackBar('Successfully updated.', 'success-toster')
          }
        }));
      }
    }
    else {
      this.router.navigate(['/sign-in'])
    }
  }

  getProductInfo() {
    let emptyGuid = "00000000-0000-0000-0000-000000000000";
    let body =
    {
      "productGuidId": emptyGuid,
      "productName": this.reviewPageName,
      "pinCode": this.pinCode
    }
    this.utils.showLoading()
    this.sub.add(  this.service.getDistributorsProductInfo(body).subscribe({
      next: (response: any) => {
        
        if (response.success) {
          this.utils.hideLoading();
          this.reviewData = response.reviewData,
          this.productName = response.productName;
        }
        else if (!response.success) {
          this.utils.hideLoading()
        }
        else {
          this.utils.hideLoading()
          this.utils.openSnackBar('Cannot fetch details', 'error-toster')
        }
      }
    }))
  }

  routeToProduct() {
    this._location.back();
  }
  ngOnDestroy(): void {

    this.sub.unsubscribe()
  }
}
